import { v4 as uuid } from "uuid";
import type { MediaAsset } from "@/features/lomdaEditorV2/lib/lomdaTypes";
import {
    parseBackgroundMediaUrl,
    DEFAULT_SCENE_BACKGROUND,
} from "@/features/lomdaEditorV2/lib/sceneBackgroundStyle";
import { isMediaElement } from "@/features/lomdaEditorV2/lib/elements/types";
import type { AssetsSlice, EditorSet, EditorGet } from "../types";

export function createAssetsSlice(
    set: EditorSet,
    _get: EditorGet
): AssetsSlice {
    return {
        assets: [],

        addAsset: (asset) =>
            set((state) => {
                state.assets.push(asset);
            }),

        addAssetFromUpload: (file) => {
            const asset: MediaAsset = {
                id: uuid(),
                fileUrl: file.fileUrl,
                fileName: file.fileName,
                fileType: file.fileType,
                fileSize: file.fileSize,
                createdAt: new Date(),
                source: "uploaded",
            };
            set((state) => {
                state.assets.push(asset);
            });
            return asset;
        },

        deleteAsset: (asset) =>
            set((state) => {
                state.assets = state.assets.filter((a) => a.id !== asset.id);
                // Cross-slice cleanup: drop any element/background referencing it.
                for (const scene of state.scenes) {
                    if (scene.elements) {
                        scene.elements = scene.elements.filter(
                            (el) =>
                                !(
                                    isMediaElement(el) &&
                                    el.media.url === asset.fileUrl
                                )
                        );
                    }
                    const bgUrl = parseBackgroundMediaUrl(scene.style?.background);
                    if (bgUrl === asset.fileUrl) {
                        const fallback =
                            scene.style?.backgroundFallback ??
                            DEFAULT_SCENE_BACKGROUND;
                        scene.style = {
                            ...(scene.style ?? {}),
                            background: fallback,
                            backgroundFallback: undefined,
                        };
                    }
                }
            }),

        replaceAssets: (assets) =>
            set((state) => {
                state.assets = assets;
            }),
    };
}
